import { ReactNode, useState } from "react";
import { I18n } from "@/i18n/I18n";

/**
 * Collapses a row of "add" buttons down to a slim insertion strip.
 *
 * At rest the row is a thin full-width strip carrying a faint "+" that brightens
 * on hover or keyboard focus. Clicking it reveals the buttons in place, where
 * they stay until dismissed — the buttons are only mounted while open, and an
 * open dropdown or modal inside them can never be torn down by the pointer
 * leaving the strip.
 */
export function CollapsibleAddRow(props: { label: string, defaultOpen?: boolean, children: ReactNode }) {
  const { label, defaultOpen = false, children } = props;
  const [open, setOpen] = useState(defaultOpen);

  if (!open) {
    return (
      <div className="add-row">
        <button
          type="button"
          className="add-row-trigger"
          onClick={() => setOpen(true)}
          aria-label={label}
          aria-expanded={false}
          title={label}
        >
          <span className="add-row-plus" aria-hidden="true">+</span>
        </button>
      </div>
    );
  }

  return (
    <div className="add-row add-row-open d-flex align-items-start gap-1">
      <div className="flex-fill">{children}</div>
      <button
        type="button"
        className="btn btn-sm text-muted px-1 py-0 add-row-close"
        onClick={() => setOpen(false)}
        aria-label={I18n.get('hideAddOptions')}
        aria-expanded
        title={I18n.get('hideAddOptions')}
      >
        &times;
      </button>
    </div>
  );
}
